import innerHeight from 'ios-inner-height';

function init() {

  const video = document.querySelector('.vimeo-wrapper');

  if (!video) {
    return;
  }

  if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
    window.onresize = resizeVideo;
  }

}

function resizeVideo() {
  const video = document.querySelector('.vimeo-wrapper');
  if (video) {
    video.style.height = innerHeight() + "px";
  }
}

window.onresize = resizeVideo;

export default init;
